module.exports = __webpack_public_path__ + "static/media/yt-chicken-choke.c3345fdb.mov";